module.exports = __webpack_public_path__ + "img/page-header.72cd896f.jpg";